import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, Label, Input, Row, Col } from 'reactstrap';
import React from 'react';
import { CRAWLER_TEMPLATE } from "./constant"
import { toast } from 'react-toastify';
const DOWNLOAD_TEMPLATE = "download";
const UPLOAD_TEMPLATE = "upload";
const SECTION_TEMPLATE = "section";


class TemplateModal extends React.PureComponent {
    state = { optionList: [], action: UPLOAD_TEMPLATE, file : undefined , sectionTemplateId : undefined , type : SECTION_TEMPLATE };

    componentDidUpdate(prevProps) {

        if (prevProps.productTemplate !== this.props.productTemplate) {
            this.prepareOptions();
        }
    }

    prepareOptions = () => {
        if (this.props.productTemplate && this.props.productTemplate.sections && this.props.productTemplate.sections.length > 0) {
            this.setState({sectionTemplateId : this.props.productTemplate.sections[0].sectionTemplateId, sectionName : this.props.productTemplate.sections[0].sectionName})
            let optionList = this.props.productTemplate.sections.map(section => {
                return <option key={section.sectionTemplateId} id={section.sectionTemplateId} name = { section.sectionName} value={section.sectionTemplateId}  selected ={this.state.sectionTemplateId === section.sectionTemplateId}> {section.sectionName}</option>
            })
            
            let index = 0, sectiontemplateIdandSectionName = {};
            for(index=0; index < this.props.productTemplate.sections.length; index++){
                sectiontemplateIdandSectionName = {...sectiontemplateIdandSectionName, [this.props.productTemplate.sections[index].sectionTemplateId] : this.props.productTemplate.sections[index].sectionName}
            }
            
            this.setState({ optionList: optionList , sectiontemplateIdandSectionName : sectiontemplateIdandSectionName});
        }
    }

    changeTemplate = (e) => {
        this.setState({sectionTemplateId : e.target.value, sectionName : this.state.sectiontemplateIdandSectionName[e.target.value] })
    }

    changeAction = (e) => {
        this.setState({ action: e.target.value });
    }

    changeSectionType = (e) => {
        this.setState({ type : e.target.value }, ()=>{
            if(this.state.type === CRAWLER_TEMPLATE){
                this.props.fetchProductDetail(CRAWLER_TEMPLATE);
            }else{
                this.props.fetchProductDetail(SECTION_TEMPLATE);
            }
        });
    }

    uploadFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        this.setState({file : file});
        e.target = null;
    }

    uploadData =(e)=>{
        e.preventDefault();
        if(this.state.file === undefined || this.state.file === null){
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>Please select File for upload !!
                </div>
            );
        }else{
            this.props.uploadTempalte({file : this.state.file, sectionTemplateId : this.state.sectionTemplateId, type : this.state.type })
        }
       
    }

    downLoadTempalte = (e) =>{
        e.preventDefault();
        this.props.downLoadTempalte({sectionTemplateId : this.state.sectionTemplateId, sectionName : this.state.sectionName, type : this.state.type })
    }
    
    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.props.open} toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle} >Quick Report Case </ModalHeader>
                    <ModalBody>
                        <Row style={{ marginLeft: "1rem" , marginBottom : "1rem" }}>
                        <Col >
                                    <Label >
                                        <Input type="radio" name="crawlerType" value={SECTION_TEMPLATE} onChange={(e) => this.changeSectionType(e)} checked ={this.state.type === SECTION_TEMPLATE}/> Section Template
                                    </Label>
                                </Col>
                                <Col >
                                    <Label >
                                        <Input type="radio" name="crawlerType" value={CRAWLER_TEMPLATE} onChange={(e) => this.changeSectionType(e)}  checked ={this.state.type === CRAWLER_TEMPLATE}/>Crawler Template
                                    </Label>
                                </Col>
                        </Row>
                       {this.state.type === CRAWLER_TEMPLATE ?
                        <Form>
                            <Row style={{ marginLeft: "1rem" }}>
                                <Col >
                                    <Label style={{ "paddingRight": "1rem" }}>
                                        Section :
                                    </Label>
                                    <select style={{ "width": "60%", }}  id="template" onChange={e => this.changeTemplate(e)}>
                                        {this.state.optionList}
                                    </select>
                                </Col>
                                <Col >
                                    <Label >
                                        <Input type="radio" name="actionType" value={DOWNLOAD_TEMPLATE} onChange={(e) => this.changeAction(e)} checked ={this.state.action === DOWNLOAD_TEMPLATE}/> Download Template
                                    </Label>
                                </Col>
                                <Col >
                                    <Label >
                                        <Input type="radio" name="actionType" value={UPLOAD_TEMPLATE} onChange={(e) => this.changeAction(e)}  checked ={this.state.action === UPLOAD_TEMPLATE}/>Upload Manual Data
                                    </Label>
                                </Col>
                            </Row>
                        </Form> :
                         <Form>
                         <Row style={{ marginLeft: "1rem" }}>
                             <Col >
                                 <Label style={{ "paddingRight": "1rem" }}>
                                     Section :
                                 </Label>
                                 <select style={{ "width": "60%", }}  id="template" onChange={e => this.changeTemplate(e)}>
                                     {this.state.optionList}
                                 </select>
                             </Col>
                             <Col >
                                 <Label >
                                     <Input type="radio" name="actionType" value={DOWNLOAD_TEMPLATE} onChange={(e) => this.changeAction(e)} checked ={this.state.action === DOWNLOAD_TEMPLATE}/> Download Template
                                 </Label>
                             </Col>
                             <Col >
                                 <Label >
                                     <Input type="radio" name="actionType" value={UPLOAD_TEMPLATE} onChange={(e) => this.changeAction(e)}  checked ={this.state.action === UPLOAD_TEMPLATE}/>Upload Manual Data
                                 </Label>
                             </Col>
                         </Row>
                     </Form>}

                    </ModalBody>
                    <ModalFooter style={{ justifyContent: "center" }}>
                        <Row>

                            { this.state.action !== DOWNLOAD_TEMPLATE && <Col>
                                <Input type="file" name="actionType" onChange={(e) => this.uploadFile(e)} /> 
                            </Col>}
                            <Col>
                                <Button color="primary" onClick ={e => {this.state.action === UPLOAD_TEMPLATE ? this.uploadData(e) : this.downLoadTempalte(e)}}>{this.state.action === DOWNLOAD_TEMPLATE ? "Download Template" : "Upload Data"}</Button>
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>
            </React.Fragment>)
    }
}

export default TemplateModal;
